<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 5L12.625 9.625L8 14.25" stroke="currentColor" stroke-width="0.925" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
